"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Service32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M15.874 28.749c7.042 0 12.75-5.708 12.75-12.75s-5.708-12.75-12.75-12.75-12.75 5.708-12.75 12.75 5.708 12.75 12.75 12.75zm0 1c-7.594 0-13.75-6.156-13.75-13.75s6.156-13.75 13.75-13.75 13.75 6.156 13.75 13.75-6.156 13.75-13.75 13.75z" }),
    react_1.default.createElement("path", { d: "M18.99 14.379l.006-.005a.076.076 0 01-.006.005zm.214-3.232c0-1.795-.925-3.267-3.204-3.267-2.276 0-3.267 1.545-3.267 3.267a.622.622 0 01-1.244 0c0-2.324 1.402-4.511 4.511-4.511 3.12 0 4.449 2.115 4.449 4.511 0 1.168-.641 2.574-1.452 3.227-.035.026-.397.297-.518.394a6.46 6.46 0 00-.62.559c-.787.816-1.237 1.781-1.237 3.006v1.556a.622.622 0 01-1.244 0v-1.556c0-1.574.589-2.837 1.586-3.87.231-.24.473-.456.739-.668.132-.105.488-.372.533-.405.496-.406.969-1.448.969-2.243zM16.622 23.5v-1a.622.622 0 00-1.244 0v1a.622.622 0 001.244 0z" }))); };
var StyledService32 = styled_components_1.default(Service32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledService32;
var templateObject_1;
//# sourceMappingURL=Service32.js.map